import {
    PLUSS_ARTICLES_SUCCESS,
    PLUSS_ARTICLES_ADD,
    PLUSS_ARTICLES_FAILURE,
} from '../actions/types';

const defaultPlussArticlesState = () => ({
    pluss: [],
    meta: {},
    error: false,
});

/* eslint-disable import/prefer-default-export */
export const fetchPlussArticlesReducer = (state = defaultPlussArticlesState(), action) => {
    if (action.type === PLUSS_ARTICLES_SUCCESS) {
        const { payload } = action;

        return {
            ...state,
            pluss: payload.articles.filter((article) => !article.error && article.id !== 'jPJ5g9'),
            meta: payload.meta,
        };
    }

    if (action.type === PLUSS_ARTICLES_ADD) {
        return {
            ...state,
            pluss: [...state.pluss].concat([
                ...action.payload.articles.filter((article) => !article.error),
            ]),
        };
    }

    if (action.type === PLUSS_ARTICLES_FAILURE) {
        return {
            ...state,
            ...action.payload,
            error: true,
        };
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/pluss-articles.js
 **/